import { Access } from "../../../../access/types.ts";
import {
  aliasParameter,
  groupDestinationParameter,
  groupNameParameter,
  parentParameter,
  requiredProviderParameter,
  sudoParameter,
} from "./parameters.ts";

export const commonGroupAccess = Access({
  description: "Group of instances",
  label: "SSH Group",
  maturity: "ga",
  delegation: {},
  generated: {
    name: {
      type: "string",
    },
  },
  parameters: {
    provider: { ...requiredProviderParameter, optional: true },
    parent: parentParameter,
    name: groupNameParameter,
    destination: groupDestinationParameter,
    sudo: sudoParameter,
    alias: aliasParameter,
    key: {
      type: "generated",
      label: "Group Key",
    },
  },
  render: { locator: "name", policy: "sudo" } as const,
});
